export default "__VITE_ASSET__Bc8NdA0d__"